import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const ContentWrapper = styled.label`
  color: #333;
  font-size: 14px;
  font-weight: 500;
`;

const ConfirmText = styled.p`
  color: #333;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
`;

const RedTitle = styled.span`
  color: red;
  font-weight: 700;
  white-space: pre-wrap;
`;

const ConfirmDeleteWarning = ({ id, htmlFor, deleteObjectTitle, children }) => {
  return (
    <ContentWrapper id={id} htmlFor={htmlFor}>
      {children}
      <ConfirmText>
        Confirm deletion by typing <RedTitle>{deleteObjectTitle}</RedTitle>{' '}
        below.
      </ConfirmText>
    </ContentWrapper>
  );
};

ConfirmDeleteWarning.defaultProps = {
  text: ''
};

ConfirmDeleteWarning.propTypes = {
  id: PropTypes.string,
  htmlFor: PropTypes.string,
  deleteObjectTitle: PropTypes.string.isRequired,
  text: PropTypes.func.isRequired
};

export default ConfirmDeleteWarning;
